import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

const HomeReservation = () => {
  return (
    <section className="bg-sm-surface text-sm-text border-t border-sm-border">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        
        {/* Booking Left */}
        <div className="p-12 md:p-24 flex flex-col justify-center border-b lg:border-b-0 lg:border-r border-sm-border relative overflow-hidden">
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl font-light italic mb-6">Rezervime</h2>
            <p className="text-sm-muted font-light leading-relaxed max-w-sm mb-12">
              Rezervoni tavolinën tuaj dhe shijoni një eksperiencë unike gastronomike në Tiranë.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <a href="/rezervo" className="group inline-flex items-center gap-4 text-sm-olive uppercase tracking-[0.2em] text-sm hover:text-sm-text transition-colors">
              <span>Bëj një rezervim</span>
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-2" />
            </a>
          </Reveal>
        </div>

        {/* Info Right */}
        <div className="p-12 md:p-24 flex flex-col justify-center">
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl md:text-5xl font-light italic mb-6">Orari</h2>
            <div className="space-y-6 text-sm-muted font-light max-w-sm">
              <div className="flex justify-between border-b border-sm-border pb-4">
                <span className="uppercase tracking-widest text-[0.7rem]">Drekë</span>
                <span className="font-serif text-sm-text">12:00 — 15:00</span>
              </div>
              <div className="flex justify-between border-b border-sm-border pb-4">
                <span className="uppercase tracking-widest text-[0.7rem]">Darkë</span>
                <span className="font-serif text-sm-text">18:00 — 23:00</span>
              </div>
            </div>
          </Reveal>
        </div>

      </div>
    </section>
  );
};

export default HomeReservation;
